import { CATALOG_UNIT_KEYS } from './shared/catalog-constants';
import { NormalizedUnitValue, UnitValue } from './shared/types';
import transformers from './transformers';

/**
 * Transforms a unit value to a new unit value. Normalizes missing/empty units to
 * 'none' before transformer lookup — the sole seam where UnitValue (units optional)
 * becomes NormalizedUnitValue (units always defined).
 */
export const transformUnits = (unitValue: UnitValue, newUnits?: string): NormalizedUnitValue => {
  const normalized: NormalizedUnitValue = {
    value: unitValue.value,
    units: unitValue.units || CATALOG_UNIT_KEYS.NONE,
  };

  const sourceKey = normalized.units.toLowerCase();
  const transformer = Object.hasOwn(transformers, sourceKey) ? transformers[sourceKey] : undefined;
  return transformer ? transformer(normalized, newUnits) : normalized;
};
